import Container from '@mui/material/Container';
import { useSelector } from 'react-redux';
import { Box } from '@mui/material';
import FormHeader from '../FormHeader/FormHeader';
import HeadlineLogo from '../HeadlineLogo/HeadlineLogo';

const FormHeaderSection = () => {
  const { headerEnabled, headlineText, headlineLogo } = useSelector(
    (store) => store.formConfig
  );
  const includeHeader =
    headerEnabled &&
    (!!headlineLogo || (headlineText !== undefined && headlineText !== null));

  if (!includeHeader) {
    return null;
  }

  return (
    <Container maxWidth="md">
      <Box
        height="100%"
        minHeight={75}
        display="flex"
        justifyContent="center"
        alignItems="center"
        flexDirection="column"
        data-testid="formHeaderContainer"
      >
        {headlineLogo ? (
          <HeadlineLogo logo={headlineLogo} />
        ) : (
          <FormHeader text={headlineText} />
        )}
      </Box>
    </Container>
  );
};

export default FormHeaderSection;
